import { ViewUIStatus } from './view-ui-status.enum';
import { MediaEnum } from 'src/app/story/models/media.enum';
import { defaultViewLoader, ViewLoaderEnum } from './view-loader.enum';

export class UIDefault {
  constructor(public status: ViewUIStatus = ViewUIStatus.Hide, public enable = true) {}
}

export class LogoUI extends UIDefault {
  constructor(public isHyperLink = true) {
    super();
  }
}

export class DrawerUI extends UIDefault {
  constructor(public isExpandedInitially = false) {
    super();
  }
}

export class MediaUI extends UIDefault {
  constructor(public template: MediaEnum = MediaEnum.Small) {
    super();
  }
}

export class LoaderUI extends UIDefault {
  constructor(public template: ViewLoaderEnum = defaultViewLoader) {
    super();
  }
}

export class LabelsUI extends UIDefault {
  constructor(public shown: boolean = true) {
    super();
  }
}

export class ViewUIModel {
  audio: UIDefault;
  camera: UIDefault;
  chapterList: UIDefault;
  column: UIDefault;
  description: UIDefault;
  drawer: DrawerUI;
  fullscreen: UIDefault;
  help: UIDefault;
  labelInfo: UIDefault;
  labelList: UIDefault;
  labels: LabelsUI;
  loader: LoaderUI;
  logo: LogoUI;
  media: MediaUI;
  menu: UIDefault;
  nodeInfo: UIDefault;
  pagination: UIDefault;
  presenter: UIDefault;
  reset: UIDefault;
  search: UIDefault;
  quiz: UIDefault;
  titleOnly: UIDefault;
  toolbar: UIDefault;
  tools: UIDefault;
  anatomyLabels: UIDefault;
  tutorial: UIDefault;
  internetExplorerWarning: UIDefault;
  legend: UIDefault;
  undo: UIDefault;
  whiteboard: UIDefault;
  visibilityLayers: UIDefault;
  contextActions: UIDefault;
  toggleLabels: UIDefault;
}
